import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "emb-card" }

import {
  ref,
  computed,
  watch,
  onMounted,
  toRefs,
  watchEffect,
  inject,
} from 'vue';
import lodash from 'lodash';
import { isMobile, isTablet } from 'mobile-device-detect';

import type {
  CommunityFutureHomePlans,
  CommunityQmiDetails,
  FutureHome,
  HeaderData,
  Lot,
  LotCountNeighborhood,
  NeighboorhoodCoords,
  NeighborhoodInfo,
  NeighborhoodPlanQmiCounts,
  NeighborhoodPlatMap,
  NeighborhoodSoldDetails,
  QmiDays,
  QmiDetails,
  SidebarHomePlan,
} from './../types';
import {
  FutureData,
  HomePlanSortOptions,
  QmiDaysFilter,
  Settings,
  SortOptions,
} from './../constant';

import SidebarPlanList from './SideBarPlanList.vue';
import Header from './AppHeader.vue';
import LeftArrowIcon from '@/assets/icons/LeftArrow.vue';

import { apiMessages } from './../api/message-api';
import { compareSortingValue, formatPrice, dateDiffInDays } from '@/core';

interface Props {
  notReservedPlan?: string[];
  coordinates?: NeighborhoodPlatMap[];
  selectedJobNum: string;
  qmiDetails: CommunityQmiDetails;
  headerOpen: boolean;
  headerData: HeaderData;
  footerOpen: boolean;
  sidebarOpen: boolean;
  homeplans: SidebarHomePlan[];
  selectedHomePlanIds: string[];
  selectedHomePlanId: string;
  selectedLotId: string;
  selectedLotStatus: string;
  availableSites: number;
  availableLots: number;
  neighborhoodId: string;
  isKioskMode: boolean;
  soldPercentage: NeighborhoodSoldDetails[];
  neighborhoods: NeighborhoodInfo[];
  selectedNeighborhoodIds: string[];
  neighborhoodsPlanQmiCount: NeighborhoodPlanQmiCounts[];
  communityHomePlans: SidebarHomePlan[];
  initialHomePlanCount: number;
  totalMobileFilterApplied: number;
  futureHomePlans: CommunityFutureHomePlans;
  planAttachedFutureLot: Set<string>;
  lotsCount: LotCountNeighborhood[];
  svg?: string;
  selectedLotIdInfo: Lot;
  isFetchedData: boolean;
  communityName: string;
  areaName: string;
  isOpenElevationModal: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
    notReservedPlan: {},
    coordinates: {},
    selectedJobNum: {},
    qmiDetails: {},
    headerOpen: { type: Boolean },
    headerData: {},
    footerOpen: { type: Boolean },
    sidebarOpen: { type: Boolean },
    homeplans: { default: () => [] },
    selectedHomePlanIds: {},
    selectedHomePlanId: {},
    selectedLotId: {},
    selectedLotStatus: {},
    availableSites: {},
    availableLots: {},
    neighborhoodId: {},
    isKioskMode: { type: Boolean },
    soldPercentage: {},
    neighborhoods: {},
    selectedNeighborhoodIds: { default: () => [] },
    neighborhoodsPlanQmiCount: {},
    communityHomePlans: {},
    initialHomePlanCount: {},
    totalMobileFilterApplied: {},
    futureHomePlans: {},
    planAttachedFutureLot: {},
    lotsCount: {},
    svg: {},
    selectedLotIdInfo: {},
    isFetchedData: { type: Boolean },
    communityName: {},
    areaName: {},
    isOpenElevationModal: { type: Boolean }
  },
  emits: ["toggleSidebar", "closeLotInfo", "updateNewHomePlanCount", "sethoverNeighborZoomLevel", "setHomePlanId", "loadNeighborhood", "applyMobileFilters", "hideSibling", "selectNeighborhood", "updatefilteredHomePlans", "setPlanNameListId", "clearSelectedNeighborhoods", "cleanHomeId", "setplanPriceExsist", "applyMobilePriceFilter", "setPlanDetailsHometypeList", "setHomeTypeCount", "setFilterProperties", "setSortProperties", "setQmiFilterProperties", "highlightNeighborhood", "openModal", "closeModal"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const isSalesOrLandView = inject('setSelectionDropdown', ref(false));

const props = __props;

const {
  notReservedPlan,
  coordinates,
  selectedJobNum,
  qmiDetails,
  headerOpen,
  headerData,
  footerOpen,
  sidebarOpen,
  homeplans,
  selectedHomePlanIds,
  selectedHomePlanId,
  selectedLotId,
  selectedLotStatus,
  availableSites,
  availableLots,
  neighborhoodId,
  isKioskMode,
  soldPercentage,
  neighborhoods,
  selectedNeighborhoodIds,
  neighborhoodsPlanQmiCount,
  communityHomePlans,
  initialHomePlanCount,
  totalMobileFilterApplied,
  futureHomePlans,
  planAttachedFutureLot,
  lotsCount,
  svg,
  selectedLotIdInfo,
  isFetchedData,
  areaName,
  communityName,
  isOpenElevationModal,
} = toRefs(props);

const siderBarHeight = ref(0);
const toolbarTopPosition = ref(0);
const filterQmiCount = ref(0);
const listHomeType = ref<string[]>([]);
const listPlanName = ref<string[]>([]);
const qmiDaysMobileFilter = ref<QmiDays[]>([]);
const appliedQmiDaysFilter = ref<QmiDays[]>([]);
const qmiAndHomeplans = ref<any[]>([]);
const filterQmiAndHomePlans = ref<any[]>([]);
const listPlanId = ref<string[]>([]);
const maxPrice = ref(0);
const minPrice = ref(0);
const showFilters = ref(false);
const selectedNeighborhoodQmiDetails = ref<any[]>([]);
const uniqueQmiCount = ref(0);
const availablePlans = ref(0);
const messages = ref<any>({});
const sortBy = ref(SortOptions.PRICE);
const sortDir = ref(-1);
const selectedSorting = ref('Price High to Low');
const isDeviceMobile = ref(false);
const hasMobile = ref(!!(isMobile && !isTablet));
const qmiAppliedMobile = ref(false);
const homeTypeCount = ref(0);
const planPriceExsist = ref(true);
const showLotInformationData = ref(false);
const lotInformationData = ref({} as Lot);
const recomputeSortedHomePlansTrigger = ref(0);

const emit = __emit;

const toggleSidebar = () => emit('toggleSidebar');

const closeLotInfo = () => emit('closeLotInfo');

const updateNewHomePlanCount = (lotId: string) =>
  emit('updateNewHomePlanCount', lotId);

const sethoverNeighborZoomLevel = (payload: {
  zoomLevel: number;
  isDisableHoverNeighbor: boolean;
  centerMap: NeighboorhoodCoords;
}) => emit('sethoverNeighborZoomLevel', payload);

const setHomePlanId = (payload) => emit('setHomePlanId', payload);

const loadNeighborhood = (
  areaName: string,
  communityName: string,
  neighborhoodName: string
) => emit('loadNeighborhood', { areaName, communityName, neighborhoodName });

const applyMobileFilters = (payload: {
  listPlanName: string[];
  listHomeType: string[];
  qmiFilterList: QmiDays[];
}) => emit('applyMobileFilters', payload);
const hideSibling = () => emit('hideSibling');

const selectNeighborhood = (neighborhoodIdArg: string) =>
  emit('selectNeighborhood', neighborhoodIdArg);

const updatefilteredHomePlans = (qmiAndHomeplansArg: any[]) =>
  emit('updatefilteredHomePlans', qmiAndHomeplansArg);

const setPlanNameListId = (listPlanIdArg: string[]) => {
  listPlanId.value = listPlanIdArg.slice(0);
  emit('setPlanNameListId', listPlanIdArg);
};
const clearSelectedNeighborhoods = () => emit('clearSelectedNeighborhoods');

const cleanHomeId = () => emit('cleanHomeId');

const setplanPriceExsist = (val: boolean) => emit('setplanPriceExsist', val);

const applyMobilePriceFilter = (payload: {
  minValue: number;
  maxValue: number;
}) => emit('applyMobilePriceFilter', payload);

const setPlanDetailsHometypeList = (payload: {
  communityHomePlans: SidebarHomePlan[];
  homeTypeList: Set<string>;
  minPrice: number;
  maxPrice: number;
}) => emit('setPlanDetailsHometypeList', payload);

const setHomeTypeCount = (count: number) => emit('setHomeTypeCount', count);

watch(
  selectedLotIdInfo,
  (newVal) => {
    if (Object.keys(newVal).length) {
      showLotInformation({ show: true, data: selectedLotIdInfo.value });
    } else {
      showLotInformation({ show: false, data: {} as Lot });
    }
  },
  {
    deep: true,
  }
);

const showLotInformation = (payload: { show: boolean; data: Lot }) => {
  showLotInformationData.value = payload.show && isSalesOrLandView.value;
  lotInformationData.value = payload.data;
};

const setFilterProperties = (
  lh: string[],
  lp: string[],
  mx: number,
  mn: number
) =>
  emit('setFilterProperties', {
    listHomeType: lh,
    listPlanName: lp,
    maxPrice: mx,
    minPrice: mn,
  });

const setSortProperties = (sortByValue: string) =>
  emit('setSortProperties', sortByValue);
const setQmiFilterProperties = (qmiFilterListArg: QmiDays[]) => {
  appliedQmiDaysFilter.value = qmiFilterListArg.slice(0);
  emit('setQmiFilterProperties', qmiFilterListArg);
};
const highlightNeighborhood = (payload: {
  neighborhoodId: string;
  display: string;
}) => emit('highlightNeighborhood', payload);

const loadMessages = async () => {
  const { messages: msgs } = await apiMessages('Sidebar');
  messages.value = msgs;
};

const toggleshowFilters = () => {
  showFilters.value = !showFilters.value;
};

const checkHomeTypeCount = () => {
  const differentHomeType = new Set<string>();
  qmiAndHomeplans.value.forEach((plan) => {
    differentHomeType.add(plan.plan_type);
  });
  homeTypeCount.value = differentHomeType.size;
  setHomeTypeCount(homeTypeCount.value);
};

const priceExsist = () => {
  return !qmiAndHomeplans.value.find(
    (plan) => plan.price ?? plan.price_low_with_premium
  );
};

const futurePlanData = (plan: any, futureHome: FutureHome) => {
  const futurePlanData: any = {};
  futurePlanData[FutureData.PLAN_MARKET_NAME] = plan.plan_name;
  futurePlanData[FutureData.PLAN_NAME] = plan.plan_name;
  futurePlanData[FutureData.PRICE] = plan.price_low_with_premium;
  futurePlanData[FutureData.ELEVATION] = futureHome.elevation;
  futurePlanData[FutureData.IMAGE] = [plan.thumbnail_img];
  futurePlanData[FutureData.ADDRESS] = futureHome.address;
  futurePlanData[FutureData.IS_FUTURE_PLAN] = true;
  futurePlanData[FutureData.JOB_NUMBER] = futureHome.job_number;
  futurePlanData[FutureData.NEIGHBORHOOD_CODE] = plan.neighborhood_code;
  futurePlanData[FutureData.PLAN_TYPE] = plan.plan_type;
  futurePlanData[FutureData.FUTURE_ID] = plan.plan_id;
  futurePlanData[FutureData.COLOR] = isSalesOrLandView.value
    ? futureHome.color
    : '#CBBE98';
  futurePlanData[FutureData.NEIGHBORHOOD_NAME] = plan.neighborhoods.find(
    (neighbor: any) => neighbor.neighborhood_code === plan.neighborhood_code
  ).neighborhood_name;
  return futurePlanData;
};

const addFutureHomePlan = (plans: any[]) => {
  const allFutureHomePlan: FutureHome[] = [];
  if (selectedNeighborhoodIds.value && selectedNeighborhoodIds.value.length) {
    allFutureHomePlan.push(
      ...(futureHomePlans.value[selectedNeighborhoodIds.value[0]] || [])
    );
  } else {
    Object.values(futureHomePlans.value || {}).forEach(
      (futurePlan: FutureHome[]) => allFutureHomePlan.push(...futurePlan)
    );
  }
  allFutureHomePlan.forEach((element) => {
    const plan = plans.find(
      (planItem) =>
        planItem.plan_name.toUpperCase() === element.plan_name.toUpperCase() &&
        !planItem.job_number
    );
    if (plan) {
      element.plan_id = plan.plan_id;
      plans.push(futurePlanData(plan, element));
    }
  });
  return plans;
};

const compareQmiFuturePlanSvgData = (container: HTMLElement) => {
  Object.keys(qmiDetails.value || {}).forEach((qmiDetail) => {
    const qmiPlans: QmiDetails[] = [];
    (qmiDetails.value[qmiDetail] || []).forEach((plan) => {
      if (container.querySelectorAll(`#${plan.job_number}`).length) {
        qmiPlans.push(plan);
      }
    });
    qmiDetails.value[qmiDetail] = qmiPlans;
  });

  Object.keys(futureHomePlans.value || {}).forEach((futurePlanKey) => {
    const futurePlanDataArr: FutureHome[] = [];
    (futureHomePlans.value[futurePlanKey] || []).forEach((plan) => {
      if (container.querySelectorAll(`#${plan.job_number}`).length) {
        futurePlanDataArr.push(plan);
      }
    });
    futureHomePlans.value[futurePlanKey] = futurePlanDataArr;
  });
};

const fixPlan = () => {
  const container = document.createElement('div');
  container.innerHTML = svg?.value || '';
  compareQmiFuturePlanSvgData(container);
};

watch(
  [selectedNeighborhoodIds, isFetchedData],
  () => {
    emit('closeModal');
    selectedNeighborhoodQmiDetails.value = [];
    fixPlan();

    if (
      !selectedNeighborhoodIds.value ||
      selectedNeighborhoodIds.value.length === 0
    ) {
      for (const key of Object.keys(qmiDetails.value || {})) {
        selectedNeighborhoodQmiDetails.value.push(
          ...(qmiDetails.value[key] || [])
        );
      }
    }

    (selectedNeighborhoodIds.value || []).forEach((neighborhoodId) => {
      selectedNeighborhoodQmiDetails.value.push(
        ...(qmiDetails.value[neighborhoodId] || [])
      );
    });

    qmiAndHomeplans.value = selectedNeighborhoodQmiDetails.value
      ? (homeplans.value || []).concat(selectedNeighborhoodQmiDetails.value)
      : homeplans.value || [];
    qmiAndHomeplans.value = addFutureHomePlan(qmiAndHomeplans.value);
    planPriceExsist.value = priceExsist();
    setplanPriceExsist(planPriceExsist.value);
    checkHomeTypeCount();

    // A Quick Move-in day filter can be applied (e.g. restored from the URL query)
    // before the QMI details exist. Re-run it now that they do, otherwise the
    // unfiltered list built above silently replaces it. Mobile re-derives the
    // filter inside sortedhomePlans, so it needs no re-run here.
    if (!hasMobile.value && appliedQmiDaysFilter.value.length) {
      qmiAndHomeplans.value = computeQmiDaysFilter(appliedQmiDaysFilter.value);
    }
  },
  { immediate: true, deep: true }
);

onMounted(() => {
  loadMessages();
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    isDeviceMobile.value = true;
  }
  calculateDynamicHeight();
});

const updateCountQmi = (plans: any[]) => {
  filterQmiCount.value = 0;
  const uniqueQmi = new Set<string>();
  plans.forEach((element) => {
    if (element.price >= 0) {
      uniqueQmi.add(element.plan_market_name);
      filterQmiCount.value++;
    }
  });

  uniqueQmiCount.value = uniqueQmi.size;
};

const getFuturePlanIds = () => {
  const futureplanIds: string[] = [];
  Object.values(futureHomePlans.value || {}).forEach((plans: FutureHome[]) => {
    const ids = plans.map((plan) => plan.plan_id);
    futureplanIds.push(...ids);
  });
  return futureplanIds;
};

const countNewHomePlans = (availablePlanCount: number) => {
  availablePlans.value = availablePlanCount - filterQmiCount.value;
  const futurePlanIds = getFuturePlanIds();
  futurePlanIds.forEach((planId) => updateNewHomePlanCount(planId));
};

const sortPlans = (
  homePlans: any[],
  sortByField: string,
  sortDirVal: number
) => {
  const arr = (homePlans || []).slice();
  return arr.sort((first, second) => {
    let field1: string | number = '';
    let field2: string | number = '';
    if (sortByField === SortOptions.PLAN) {
      field1 = first.plan_name.toLowerCase();
      field2 = second.plan_name.toLowerCase();
    } else {
      field1 = availableSites.value
        ? first.price ?? first.price_low_with_premium
        : first.plan_name;
      field2 = availableSites.value
        ? second.price ?? second.price_low_with_premium
        : second.plan_name;
    }

    if (
      sortDirVal === 1 ||
      (!availableSites.value && sortByField === SortOptions.PRICE)
    ) {
      return compareSortingValue(field1 as any, field2 as any);
    }
    return compareSortingValue(field2 as any, field1 as any);
  });
};

const filterSortMediator = (sortedHomePlanData: any[]) => {
  let filterQmiAndHomePlansLocal = sortedHomePlanData;
  if (listHomeType.value.length) {
    filterQmiAndHomePlansLocal = sortedHomePlanData.filter((homePlan) =>
      listHomeType.value.includes(homePlan.plan_type)
    );
  }
  if (isApplyPrice() && !planPriceExsist.value) {
    filterQmiAndHomePlansLocal = filterQmiAndHomePlansLocal.filter(
      (element) =>
        maxPrice.value >= (element.price ?? element.price_low_with_premium) &&
        minPrice.value <= (element.price ?? element.price_low_with_premium)
    );
  }
  const listTypeFilter = filterQmiAndHomePlansLocal.filter((element) => {
    const data = element.plan_market_name ?? element.plan_name;
    return listPlanName.value.includes(data);
  });
  if (listTypeFilter.length || listPlanName.value.length) {
    filterQmiAndHomePlansLocal = listTypeFilter;
  }
  return filterQmiAndHomePlansLocal;
};

const filtersort = (sortedHomePlanData: any[]) => {
  if (
    !listHomeType.value.length &&
    !listPlanName.value.length &&
    !minPrice.value &&
    !maxPrice.value
  )
    return sortedHomePlanData;
  return filterSortMediator(sortedHomePlanData);
};

const separateCommunityPlans = (qmiAndHomeplans: any) => {
  let plans: any = [];
  qmiAndHomeplans.forEach((plan) => {
    if (selectedNeighborhoodIds.value.includes(plan.neighborhood_code)) {
      plans.push(plan);
    } else if (
      selectedNeighborhoodIds.value &&
      selectedNeighborhoodIds.value.length &&
      plan.neighborhoods
    ) {
      const planNeighborhoods: string[] = [];
      plan.neighborhoods.forEach((neighborhood: any) =>
        planNeighborhoods.push(neighborhood.neighborhood_code)
      );
      if (planNeighborhoods.includes(selectedNeighborhoodIds.value[0]))
        plans.push(plan);
    }
  });
  return plans;
};

const sortByPrice = (planData: any[]) => {
  let plans: any = [];
  if (availableSites.value && sortBy.value === SortOptions.PRICE) {
    let plansWithoutPrice = planData.filter(
      (plan) => !(plan.price ?? plan.price_low_with_premium)
    );
    let plansWithPrice = planData.filter(
      (plan) => plan.price ?? plan.price_low_with_premium
    );
    plansWithoutPrice = sortPlans(plansWithoutPrice, SortOptions.PLAN, 1);
    plansWithPrice = sortPlans(plansWithPrice, sortBy.value, sortDir.value);
    plans = plansWithPrice.concat(plansWithoutPrice);
  } else {
    plans = sortPlans(planData, sortBy.value, sortDir.value);
  }

  return plans;
};

const setQmiDaysMobileFilter = (payload: QmiDays[]) => {
  qmiDaysMobileFilter.value = payload.slice(0);
  qmiAndHomeplans.value = computeQmiDaysFilter(payload);
};

const showQmiHomeplans = (qmiFilter: boolean) => {
  let result: any[] = [];
  if (qmiFilter) {
    result = selectedNeighborhoodQmiDetails.value
      ? selectedNeighborhoodQmiDetails.value
      : [];
  } else {
    result =
      selectedNeighborhoodQmiDetails.value && !qmiFilter
        ? (homeplans.value || []).concat(selectedNeighborhoodQmiDetails.value)
        : homeplans.value || [];
    setQmiFilterProperties([]);
  }
  result = addFutureHomePlan(result);
  return result;
};

const calculateDynamicHeight = (height?: number) => {
  const headerEl = document.getElementById('header') as HTMLElement | null;
  const footerEl = document.getElementById('footer') as HTMLElement | null;
  const vh = height ? height : window.innerHeight;
  siderBarHeight.value = getSidebarHeight(vh, headerEl, footerEl);
  toolbarTopPosition.value = getToolbarTopPosition(headerEl);
};

const setSorting = (sortOption: any) => {
  setSortProperties(sortOption.value);
  sortBy.value = sortOption.sortField;
  sortDir.value = sortOption.sortDirection;
  selectedSorting.value = sortOption.value;
};

const compare = (first: string | number, second: string | number) => {
  if (first < second) return -1;
  if (first > second) return 1;
  return 0;
};

const filterPlanNameHomeType = (payload: {
  listHomeType: string[];
  listPlanName: string[];
  maxPrice: number;
  minPrice: number;
}) => {
  const {
    listHomeType: lh,
    listPlanName: lp,
    maxPrice: mx,
    minPrice: mn,
  } = payload;
  listHomeType.value = lh;
  listPlanName.value = lp;
  maxPrice.value = mx;
  minPrice.value = mn;
  setFilterProperties(lh, lp, mx, mn);
};

const isApplyPrice = () => {
  if (selectedNeighborhoodIds.value && selectedNeighborhoodIds.value.length) {
    const currentNeighborhood = (soldPercentage.value || []).filter(
      (element) => element.neighborhoodId === selectedNeighborhoodIds.value[0]
    );
    return (
      currentNeighborhood.length > 0 &&
      currentNeighborhood[0].soldPercentage !== 100
    );
  } else {
    const currentNeighborhood = (soldPercentage.value || []).filter(
      (element) => element.soldPercentage !== 100
    );
    return currentNeighborhood.length > 0;
  }
};

const filteredQmis = (qmiFilterList: QmiDays[], currDate: Date) => {
  const otherDaysFilter = qmiFilterList.filter(
    (filter) => filter.days !== Settings.MaxValue
  );
  const qmisBeyondNinetyDays = selectedNeighborhoodQmiDetails.value.filter(
    (plan: QmiDetails) =>
      dateDiffInDays(currDate, new Date(plan.move_in_date)) > 90
  );
  if (otherDaysFilter.length) {
    const maxDaysDifference = otherDaysFilter.reduce(
      (r, qmi) => Math.max(r, qmi.days),
      0
    );
    const remainingQmis = selectedNeighborhoodQmiDetails.value.filter(
      (plan: QmiDetails) =>
        dateDiffInDays(currDate, new Date(plan.move_in_date)) <=
        maxDaysDifference
    );
    return qmisBeyondNinetyDays.concat(remainingQmis);
  }
  return qmisBeyondNinetyDays;
};

// const applyQmiDaysFilter = (qmiFilterList: QmiDays[]) => {
//   setQmiFilterProperties(qmiFilterList);
//   const maxDaysDifference = qmiFilterList.reduce((r, qmi) => Math.max(r, qmi.days), 0);
//   const currDate = new Date(new Date().toLocaleString('en-us', { timeZone: 'America/Chicago' }));
//   if (selectedNeighborhoodQmiDetails.value && maxDaysDifference) {
//     qmiAndHomeplans.value = selectedNeighborhoodQmiDetails.value.filter((plan: QmiDetails) => dateDiffInDays(currDate, new Date(plan.move_in_date)) <= maxDaysDifference);
//     if (hasMobile.value) qmiAppliedMobile.value = true;
//     if (maxDaysDifference === Settings.MaxValue) {
//       qmiAndHomeplans.value = qmiFilterList.length === QmiDaysFilter.length ? qmiAndHomeplans.value : filteredQmis(qmiFilterList, currDate);
//     }
//   } else {
//     qmiAndHomeplans.value = [];
//     if (hasMobile.value) qmiAppliedMobile.value = false;
//   }
// };

const computeQmiDaysFilter = (qmiFilterList: QmiDays[]): any[] => {
  setQmiFilterProperties(qmiFilterList);
  const maxDaysDifference = qmiFilterList.reduce(
    (r, qmi) => Math.max(r, qmi.days),
    0
  );
  const currDate = new Date(
    new Date().toLocaleString('en-us', { timeZone: 'America/Chicago' })
  );
  if (selectedNeighborhoodQmiDetails.value && maxDaysDifference) {
    let filteredDetails: any[] = [];
    filteredDetails = selectedNeighborhoodQmiDetails.value.filter(
      (plan: QmiDetails) =>
        dateDiffInDays(currDate, new Date(plan.move_in_date)) <=
        maxDaysDifference
    );
    if (hasMobile.value) qmiAppliedMobile.value = true;
    if (maxDaysDifference === Settings.MaxValue) {
      filteredDetails =
        qmiFilterList.length === QmiDaysFilter.length
          ? filteredDetails
          : filteredQmis(qmiFilterList, currDate) ?? [];
    }
    return filteredDetails;
  } else {
    if (hasMobile.value) qmiAppliedMobile.value = false;
    return [];
  }
};

const clearQmiDaysFilter = (isQmiSelected: boolean) => {
  if (selectedNeighborhoodQmiDetails.value && isQmiSelected) {
    qmiAndHomeplans.value = selectedNeighborhoodQmiDetails.value;
  } else if (selectedNeighborhoodQmiDetails.value && !isQmiSelected) {
    qmiAndHomeplans.value = (homeplans.value || []).concat(
      selectedNeighborhoodQmiDetails.value
    );
  } else if (!selectedNeighborhoodQmiDetails.value && !isQmiSelected) {
    qmiAndHomeplans.value = homeplans.value || [];
  }
  if (!isQmiSelected) setQmiFilterProperties([]);
};

const getSidebarHeight = (
  vh: number,
  header: HTMLElement | null,
  footer: HTMLElement | null
) => {
  return (
    vh -
    ((header ? header.clientHeight : 0) +
      (footer ? footer.clientHeight : 0) +
      getTopOuterHeight() +
      getBottomOuterHeight())
  );
};
const getToolbarTopPosition = (header: HTMLElement | null) =>
  (header && header.clientHeight ? header.clientHeight : 0) +
  getTopOuterHeight();
const getTopOuterHeight = () =>
  isMobile && !isTablet
    ? Settings.TOP_OUTER_HEIGHT_MOBILE
    : Settings.TOP_OUTER_HEIGHT_TABLET;
const getBottomOuterHeight = () =>
  isMobile && !isTablet
    ? Settings.BOTTOM_OUTER_HEIGHT_MOBILE
    : Settings.BOTTOM_OUTER_HEIGHT_TABLET;

const sortedhomePlans = computed(() => {
  recomputeSortedHomePlansTrigger.value;
  let result: any[] = [];
  const hasQmiFilter = hasMobile.value && qmiDaysMobileFilter.value.length > 0;
  const hasNeighborhoodFilter = selectedNeighborhoodIds.value.length > 0;

  if (hasQmiFilter) {
    result = computeQmiDaysFilter(qmiDaysMobileFilter.value);
  } else if (hasMobile.value) {
    result = showQmiHomeplans(false);
  } else {
    result = [...qmiAndHomeplans.value];
  }
  if (hasNeighborhoodFilter) {
    result = separateCommunityPlans(result);
  }

  result = sortByPrice(result);
  return filtersort(result);
});

watch(
  sortedhomePlans,
  (plans) => {
    filterQmiAndHomePlans.value = plans;
    updatefilteredHomePlans(plans);
    updateCountQmi(plans);
    countNewHomePlans(plans.length);
  },
  {
    immediate: true,
  }
);

const updateQmiFilterData = (val) => {
  qmiAndHomeplans.value = val;
  recomputeSortedHomePlansTrigger.value++;
};

const showQmiPlanData = (val) => {
  qmiAndHomeplans.value = val;
  recomputeSortedHomePlansTrigger.value++;
};

__expose({
  homeTypeCount,
  checkHomeTypeCount,
  calculateDynamicHeight,
  filterPlanNameHomeType,
  setQmiDaysMobileFilter,
});

return (_ctx: any,_cache: any) => {
  return ((hasMobile.value && _unref(sidebarOpen)) || !hasMobile.value)
    ? (_openBlock(), _createElementBlock("aside", {
        key: 0,
        class: _normalizeClass([
      'embsidebar',
      { slideLeft: !_unref(sidebarOpen) && !isDeviceMobile.value },
      { 'is-open': showFilters.value },
    ])
      }, [
        _createElementVNode("div", {
          onClick: toggleSidebar,
          class: _normalizeClass([
        'sidebarToggleBtn dsize',
        { hidden: !_unref(sidebarOpen) },
        { disabled: _unref(isOpenElevationModal) },
      ]),
          disabled: _unref(isOpenElevationModal)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(LeftArrowIcon),
            _createVNode(LeftArrowIcon)
          ])
        ], 10, _hoisted_1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["emb-card_body", [{ 'scrollbar sidebar-scroll': _unref(isSalesOrLandView) }]])
          }, [
            _createVNode(Header, {
              initialHomePlanCount: _unref(initialHomePlanCount),
              headerData: _unref(headerData),
              availableSites: _unref(availableSites),
              neighborhoods: _unref(neighborhoods),
              selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
              qmiAndHomeplans: qmiAndHomeplans.value,
              availableLots: _unref(availableLots),
              availablePlans: availablePlans.value,
              isKioskMode: _unref(isKioskMode),
              selectedLotId: _unref(selectedLotId),
              selectedLotStatus: _unref(selectedLotStatus),
              messages: messages.value,
              selectedSorting: selectedSorting.value,
              soldPercentage: _unref(soldPercentage),
              neighborhoodsPlanQmiCount: _unref(neighborhoodsPlanQmiCount),
              qmiDetails: _unref(qmiDetails),
              communityHomePlans: _unref(communityHomePlans),
              filterQmiCount: uniqueQmiCount.value,
              qmiAppliedMobile: qmiAppliedMobile.value,
              sidebarOpen: _unref(sidebarOpen),
              homeTypeCount: homeTypeCount.value,
              planPriceExsist: planPriceExsist.value,
              totalMobileFilterApplied: _unref(totalMobileFilterApplied),
              coordinates: _unref(coordinates),
              showSelectedLotInformation: showLotInformationData.value,
              lotInformationData: lotInformationData.value,
              updateQmiData: computeQmiDaysFilter,
              showQmiPlans: showQmiHomeplans,
              areaName: _unref(areaName),
              communityName: _unref(communityName),
              onHideSibling: hideSibling,
              onToggleshowFilters: toggleshowFilters,
              onSetSorting: setSorting,
              onCloseLotInfo: closeLotInfo,
              onLoadNeighborhood: loadNeighborhood,
              onSelectNeighborhood: selectNeighborhood,
              onFilterPlanNameHomeType: filterPlanNameHomeType,
              onSetPlanNameListId: setPlanNameListId,
              onClearSelectedNeighborhoods: clearSelectedNeighborhoods,
              onShowQmiHomeplans: showQmiHomeplans,
              onClearQmiDaysFilter: clearQmiDaysFilter,
              onSetPlanDetailsHometypeList: setPlanDetailsHometypeList,
              onApplyMobileFilters: applyMobileFilters,
              onApplyMobilePriceFilter: applyMobilePriceFilter,
              onHighlightNeighborhood: highlightNeighborhood,
              onSethoverNeighborZoomLevel: sethoverNeighborZoomLevel,
              onUpdateQmiFilterData: updateQmiFilterData
            }, null, 8, ["initialHomePlanCount", "headerData", "availableSites", "neighborhoods", "selectedNeighborhoodIds", "qmiAndHomeplans", "availableLots", "availablePlans", "isKioskMode", "selectedLotId", "selectedLotStatus", "messages", "selectedSorting", "soldPercentage", "neighborhoodsPlanQmiCount", "qmiDetails", "communityHomePlans", "filterQmiCount", "qmiAppliedMobile", "sidebarOpen", "homeTypeCount", "planPriceExsist", "totalMobileFilterApplied", "coordinates", "showSelectedLotInformation", "lotInformationData", "areaName", "communityName"]),
            _createVNode(SidebarPlanList, {
              initialHomePlanCount: _unref(initialHomePlanCount),
              qmiAndHomeplans: sortedhomePlans.value,
              selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
              selectedHomePlanIds: _unref(selectedHomePlanIds),
              selectedLotId: _unref(selectedLotId),
              selectedLotStatus: _unref(selectedLotStatus),
              selectedHomePlanId: _unref(selectedHomePlanId),
              isKioskMode: _unref(isKioskMode),
              availableLots: _unref(availableLots),
              neighborhoodId: _unref(neighborhoodId),
              listPlanId: listPlanId.value,
              listHomeType: listHomeType.value,
              selectedJobNum: _unref(selectedJobNum),
              lotsCount: _unref(lotsCount),
              onSetHomePlanId: setHomePlanId,
              onToggleshowFilters: toggleshowFilters,
              onCleanHomeId: cleanHomeId,
              onOpenModal: _cache[0] || (_cache[0] = (payload) => emit('openModal', payload)),
              onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (emit('closeModal')))
            }, null, 8, ["initialHomePlanCount", "qmiAndHomeplans", "selectedNeighborhoodIds", "selectedHomePlanIds", "selectedLotId", "selectedLotStatus", "selectedHomePlanId", "isKioskMode", "availableLots", "neighborhoodId", "listPlanId", "listHomeType", "selectedJobNum", "lotsCount"])
          ], 2)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})